export enum MovementType {
Entry,
Exit,
Unknown,
}
